import { createContext, useState, useContext } from "react";

const ModalContext = createContext();

let modalController = {
  openModal: () => {},
  closeModal: () => {},
};

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [modalData, setModalData] = useState({ open: false, message: "" });

  const openModal = (message) => setModalData({ open: true, message });
  const closeModal = () => setModalData({ open: false, message: "" });

  modalController.openModal = openModal;
  modalController.closeModal = closeModal;

  return (
    <ModalContext.Provider value={{ modalData, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const modal = modalController;

